function getAncestors(member) {
    const ancestors = [];
    if (member._father) {
        ancestors.push(member._father);
    }
    if (member._mother) {
        ancestors.push(member._mother);
    }
    return ancestors;
}
function getDescendents(member) {
    return [...member._sons, ...member._daughters];
}
export default { getAncestors, getDescendents };
